import { Button } from "@/components/ui/button";
import { RadioQuestion } from "./QuestionTypes/RadioQuestion";
import { RadioWithOtherQuestion } from "./QuestionTypes/RadioWithOtherQuestion";
import { CheckboxQuestion } from "./QuestionTypes/CheckboxQuestion";
import { CheckboxWithOtherQuestion } from "./QuestionTypes/CheckboxWithOtherQuestion";
import { NumberQuestion } from "./QuestionTypes/NumberQuestion";
import { TextQuestion } from "./QuestionTypes/TextQuestion";
import { RankQuestion } from "./QuestionTypes/RankQuestion";

interface QuestionFormProps {
  question: {
    id: string;
    question: string;
    options?: string[];
    question_type: string;
  };
  answer: string | string[];
  onAnswerChange: (value: string | string[]) => void;
  onBack: () => void;
  onNext: () => void;
  isLastQuestion: boolean;
}

export const QuestionForm = ({
  question,
  answer,
  onAnswerChange,
  onBack,
  onNext,
  isLastQuestion,
}: QuestionFormProps) => {
  const renderQuestionType = () => {
    switch (question.question_type) {
      case 'radio':
        return (
          <RadioQuestion
            options={question.options || []}
            value={answer as string}
            onChange={onAnswerChange}
          />
        );
      case 'radio_with_other':
        return (
          <RadioWithOtherQuestion
            options={question.options || []}
            value={answer as string}
            onChange={onAnswerChange}
          />
        );
      case 'checkbox':
        return (
          <CheckboxQuestion
            options={question.options || []}
            value={Array.isArray(answer) ? answer : []}
            onChange={onAnswerChange}
          />
        );
      case 'checkbox_with_other':
        return (
          <CheckboxWithOtherQuestion
            options={question.options || []}
            value={Array.isArray(answer) ? answer : []}
            onChange={onAnswerChange}
          />
        );
      case 'number':
        return (
          <NumberQuestion
            value={answer as string}
            onChange={onAnswerChange}
          />
        );
      case 'text':
        return (
          <TextQuestion
            value={answer as string}
            onChange={onAnswerChange}
          />
        );
      case 'rank':
        return (
          <RankQuestion
            options={question.options || []}
            value={Array.isArray(answer) ? answer : question.options || []}
            onChange={onAnswerChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6 text-foreground">
      {renderQuestionType()}
      
      <div className="flex justify-between mt-6">
        <Button
          variant="outline"
          onClick={onBack}
          className="border-green-500 text-green-500 hover:bg-green-500/10 hover:text-green-500"
        >
          Back
        </Button>
        <Button 
          onClick={onNext}
          className="bg-[#00DC82] text-white hover:bg-[#00DC82]/90"
        >
          {isLastQuestion ? "Submit" : "Next"}
        </Button>
      </div>
    </div>
  );
};